import { useMutation } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { DELETE_MY_ACCOUNT } from '../../apollo/mutations/user';
import { logoutUser } from '../../redux/slices/authSlice';


const useDeleteAccount = () => {
  const dispatch = useDispatch();
  const [deleteMyAccountMutation, { loading, error }] = useMutation(DELETE_MY_ACCOUNT);

  const deleteMyAccount = async () => {
    try {
      await deleteMyAccountMutation();
      
      dispatch(logoutUser());

      setTimeout(() => {
        window.location.href = '/';
      }, 300);
    } catch (err) {
      console.error('Failed to delete account:', err);
      throw err;
    }
  };

  return { deleteMyAccount, loading, error };
};

export default useDeleteAccount;